module.exports = __webpack_public_path__ + "static/media/gpTRAC_PrimaryLogo_NoTAG_3C.f824bf84.svg";